import { render, staticRenderFns } from "./addSalePerson.vue?vue&type=template&id=71ebcfa0&scoped=true&"
import script from "./addSalePerson.vue?vue&type=script&lang=js&"
export * from "./addSalePerson.vue?vue&type=script&lang=js&"
import style0 from "./addSalePerson.vue?vue&type=style&index=0&id=71ebcfa0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ebcfa0",
  null
  
)

export default component.exports